import { trackersSafeParams } from '../../internal/platformMetrics/trackers';
export const PLATFORM_METRICS_REPORT_PARAMETERS = [
    'issued_at'
];
export const PLATFORM_METRICS_PARAMETERS = [
    ...trackersSafeParams,
    ...PLATFORM_METRICS_REPORT_PARAMETERS
];

//# sourceMappingURL=constants.js.map